define('TescoMobile_DataLayer/js/model/messages-mixin',['jquery'], function ($) {
  'use strict';

  var mixin = {
    addErrorMessage: function (message) {
      let responseData = {
        'response_code': '',
        'message': ''
      };
      if (!!message.response_code) {
        responseData['response_code'] = message.response_code;
      }
      if (!!message.message) {
        var messageText = message.message,
          replaceNumber;
        if (!!(message !== null && message !== void 0 && message.parameters) && message !== null && message !== void 0 && message.parameters.length) {
          _.each(message.parameters, function (param, key) {
            replaceNumber = key + 1;
            messageText = messageText.replace('%' + replaceNumber, param);
          });
        }
        responseData['message'] = messageText;
      } else if (!!message.responseText) {
        var jsonData = JSON.parse(message.responseText);
        if (!!jsonData['message']) {
          responseData['message'] = jsonData['message'];
        }
      }
      $.data(document.body, 'dl-error-processor-response', responseData);
      $('body').trigger('dl-error-processor-response');
      return this._super(message);
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

